import React, { Component } from 'react';
import _ from 'lodash';
import { Grid, Button, Icon, Popup } from 'semantic-grab-ui/src';
import Toastr from 'utils/toastr-util';
import { userTypeToTemplateAppName, actionTypeToTemplateType } from 'data/trident-campaigns';
import Widget from 'hedwig-dash/components/widget/search';

interface Props {
  targetUserType: string;
  actionType: string;
  templateName: string;
  user: string; // slack user name
  onSelect: (template?: TemplateSelectData) => void;
  showMyTemplate?: boolean;
}

interface State {
  myTemplateOnly: boolean;
}

interface TemplateSelectData {
  templateId: string;
  templateName: string;
}

const PAGE_SIZE = 30;

// HedwigWidget is a wrapper around hedwig' search widget + a toggle for searching my template only
export default class HedwigWidget extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      myTemplateOnly: false,
    };
  }

  handleSelect = (template: TemplateSelectData) => {
    this.props.onSelect(template);
  };

  handleError = (err: any) => {
    Toastr.error(`Template search failed with ${err}`);
  };

  getAppName = (): string => {
    const { actionType, targetUserType } = this.props;

    // Special handling for bulkSendEmailByAddress
    if (actionType === 'bulkSendEmailByAddress') {
      if (targetUserType === 'foodmax') {
        return 'umex';
      }
      if (targetUserType === 'passenger') {
        return 'upax';
      }
    }

    // Default behavior for other action types
    return _.get(userTypeToTemplateAppName, targetUserType, '');
  };

  render() {
    const createdByFilter = this.state.myTemplateOnly ? this.props.user : '';

    return (
      <Grid.Row>
        <Grid.Column width={14}>
          <Widget
            appName={this.getAppName()}
            templateType={_.get(actionTypeToTemplateType, this.props.actionType, this.props.actionType)} /* this.props.actionType on Ucd Guided Campaign page could be an array. e.g: "push,inbox,email" */
            createdBy={createdByFilter}
            initialValue={this.props.templateName}
            pageSize={PAGE_SIZE}
            apiGatewayUrl={window.Grab.config.API_BASE_URL}
            onSelect={this.handleSelect}
            onError={this.handleError}
          />
        </Grid.Column>
        {this.props.showMyTemplate !== false && <Grid.Column width={2}>
          <Popup
            trigger={
              <Button
                positive={this.state.myTemplateOnly} onClick={
                  () => {
                    this.setState({
                      myTemplateOnly: !this.state.myTemplateOnly,
                    });
                  }
                }
              >
                <Icon name="user" />
              </Button>
            }
            content={`Turn ${this.state.myTemplateOnly ? 'Off' : 'On'} My Templates Only`}
          />
        </Grid.Column>
        }
      </Grid.Row>
    );
  }
}
